import React, { useState } from "react";

import { Container } from "./styles";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function InputPassword({
  id,
  label,
  placeholder,
  maxLength,
  mensagemErro,
  value,
  handler,
  required,
  handlerKeyDown,
  tip,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Container>
      <label>{label}</label>
      <small>{tip}</small>
      <div>
        <input
          {...rest}
          id={id}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          maxLength={maxLength ? maxLength : ""}
          onChange={handler}
          onKeyDown={handlerKeyDown}
          required={required}
          style={mensagemErro ? { borderBottom: "1px solid red" } : {}}
        />
        <span onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default InputPassword;
